import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {FilterUtil} from "../../../util/filter.util";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {
  AddOrUpdateAttributeTypeOptions
} from "../dialog/add-or-update-attribute-type/options/add-or-update-attribute-type.options";
import {
  AddOrUpdateAttributeTypeComponent
} from "../dialog/add-or-update-attribute-type/add-or-update-attribute-type.component";
import {DataResponse} from "../../../network/service/data.response";
import {VerifyComponent} from "../../dialog/verify/verify.component";
import {VerifyOptions} from "../../dialog/verify/options/verify.options";

@Component({
  selector: 'app-attribute-types',
  standalone: false,
  templateUrl: './attribute-types.component.html',
  styleUrls: ['./attribute-types.component.scss']
})
export class AttributeTypesComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'Title', 'AttributeType'];
  displayDataSources = ['edit', 'delete', 'Title', 'Type'];
  displayColumnTypes = ['event', 'event', 'string', 'string'];
  displayEndPoint = [this.ServicePath.UPDATE_ATTRIBUTE_TYPE, this.ServicePath.DELETE_ATTRIBUTE_TYPE, '', ''];
  attributeTypes: any = [];
  allFilters = FilterUtil.AttributeTypesFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getAttributeType(this.tableProperties.offset, this.tableProperties.limit, undefined, undefined, {
      Filter: this.filters,
      Order: this.tableProperties.order ?? {
        Field: 'ModifyDate',
        Type: 'DESC'
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.attributeTypes = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.attributeTypes) {
      for (let i = 0; i < this.attributeTypes.length; i++) {
        this.attributeTypes[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.attributeTypes[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    let addOrUpdateAttributeTypeOptions = new AddOrUpdateAttributeTypeOptions();
    addOrUpdateAttributeTypeOptions.attributeType = {};
    addOrUpdateAttributeTypeOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateAttributeTypeComponent = this.matDialog.open(AddOrUpdateAttributeTypeComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateAttributeTypeComponent.componentInstance.addOrUpdateAttributeTypeOptions = addOrUpdateAttributeTypeOptions;
  }

  onUpdateClicked(index: number) {
    let addOrUpdateAttributeTypeOptions = new AddOrUpdateAttributeTypeOptions();
    addOrUpdateAttributeTypeOptions.attributeType = this.attributeTypes[index];
    addOrUpdateAttributeTypeOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateAttributeTypeComponent = this.matDialog.open(AddOrUpdateAttributeTypeComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateAttributeTypeComponent.componentInstance.addOrUpdateAttributeTypeOptions = addOrUpdateAttributeTypeOptions;
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteAttributeType(this.attributeTypes[index].AttributeTypeId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }
}
